<template>
  <div class="serve-contain">
    <div class="server-contain">
      <div
        class="platform-contain"
        v-for="(item, index) in serverData"
        :key="index"
        @click="serverChange(item.url)"
      >
        <div class="server-image">
          <img :src="item.img" :alt="item.title" />
        </div>
        <div class="server-bottom">
          <div class="server-left">
            <h2>{{ item.title }}</h2>
            <div>{{ item.name }}</div>
          </div>
          <div class="server-right" v-if="item.isimg">
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="serveCase-contain">
      <div class="serveCase-left">
        <h1>新闻中心</h1>
        <h2>News Center</h2>
      </div>
      <div class="serveCase-tab">
        <div
          v-for="(item, index) in tabData"
          :key="index"
          @click="serveChange(item)"
        >
          <router-link
            tag="a"
            :to="{ path: 'News', query: { type: item.name } }"
            class="tabName"
            :class="item.id == tabs ? 'active' : 'tabName'"
          >
            {{ item.name }}
          </router-link>
        </div>
      </div>
      <div class="serveCase-right">
        <router-link tag="a" to="News" class="more-news">MORE</router-link>
      </div>
    </div>
    <div class="imgfont-contain">
      <router-link tag="a" to="News/6" class="medical-left">
        <div class="img-top">
          <img src="../../../../static/images/server19.png" alt="新闻中心" />
        </div>
        <div class="medical-contain">
          <div class="appliance-left">
            <div>07</div>
            <div>2021-05</div>
          </div>
          <div class="appliance-right">
            <h1>
              前海高扬联合创办并授牌100个中心城市的线下实体“
              共享服务中心”
            </h1>
            <div class="underline1"></div>
            <div class="particulars">
              2021年4月10日，在第十一届设备行业数据发布大会上，杂志社作为创始人...
            </div>
          </div>
        </div>
      </router-link>
      <div class="medical-right">
        <div class="medical-top">
          <div class="new-left">
            <router-link tag="a" to="News/1" class="news-title">
              2020年为什么这么多公司一直招人
            </router-link>
            <div class="underline2"></div>
            <router-link tag="a" to="News/1" class="news-title-detail">
              年后招聘猛增，尤其是器械维修工程师岗位，我所在的X射线细分领域来说，具体有以下几方面...
            </router-link>
          </div>
          <div class="new-right">
            <div class="date-contain">
              <div>28</div>
              <div>2021-02</div>
            </div>
            <router-link tag="a" to="News/1" class="angle-right">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </router-link>
          </div>
        </div>
        <router-link
          tag="a"
          :to="item.url"
          class="medical-bottom-contain"
          v-for="(item, index) in medicalData"
          :key="index"
        >
          <div class="medical-bottom" :class="item.className">
            <h3>{{ item.name }}</h3>
            <div>{{ item.date }}</div>
          </div>
          <div class="underline3"></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serverData: [
        {
          img: "../../../../static/images/server1.png",
          title: "联合服务",
          name: "业内外资整合，线上与线下结合，打造服务产业链",
          isimg: false
        },
        {
          img: "../../../../static/images/server2.png",
          title: "派单平台",
          name:
            "以服务为中心 以用户需求为核心确保设备安全运行 解决现场服务响应效率 ",
          isimg: true,
          url: "/Service"
        },
        {
          img: "../../../../static/images/server1.png",
          title: "合作库平台",
          name: "自助设备备件资源共享以供应链标准化管理体系为基础",
          isimg: true,
          url: "/Cooperation"
        }
      ],
      tabData: [
        { name: "全部", id: 1 },
        { name: "行业资讯", id: 2 },
        { name: "培训中心", id: 3 }
      ],
      medicalData: [
        {
          name: "如何使设备发挥出最佳的功能日益重要",
          date: "2021-02-26",
          className: "server-text",
          url: "/News/2"
        },
        {
          name: "行业趋势及设备维修技术探讨",
          date: "2021-02-26",
          url: "/News/3"
        },
        {
          name: "售后维修服务正逐渐成为下一个风口",
          date: "2021-02-26",
          url: "/News/4"
        },
        {
          name: "设备日常巡检保养的重要性",
          date: "2021-02-26",
          url: "/News/5"
        }
      ],
      tabs: 1
    };
  },
  methods: {
    serveChange(e) {
      this.tabs = e;
    },
    serverChange(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style scoped lang="less">
.serve-contain {
  width: 1170px;
  margin: 0 auto;
  margin-top: 60px;
  .server-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .platform-contain:hover {
      border-bottom: 1px solid #999999;
      box-shadow: 0px 13px 42px rgba(0, 0, 0, 0.05);
      transition: 0.5s;
      .server-image {
        transition: all 0.5s;
        overflow: hidden;
        img {
          transform: scale(1.1);
          transition: all 0.5s;
        }
      }
      .server-bottom {
        .server-left {
          transform: translateX(10px);
          transition: all 0.5s;
        }
        .server-right {
          .el-icon-right {
            font-size: 22px;
            color: #444444;
            transition: all 0.5s;
          }
        }
      }
    }
    .platform-contain {
      width: 32%;
      border-bottom: 1px solid #e5e5e5;
      cursor: pointer;
      transition: 0.5s;
      .server-image {
        width: 100%;
        height: 184px;
        overflow: hidden;
        transition: all 0.5s;
        img {
          width: 100%;
          height: 184px;
          transform: scale(1);
          transition: all 0.5s;
        }
      }
      .server-bottom {
        width: 100%;
        display: flex;
        flex-direction: row;
        .server-left {
          width: 80%;
          height: 80px;
          padding-left: 20px;
          line-height: 0;
          margin-top: 15px;
          display: flex;
          flex-direction: column;
          transform: translateX(0);
          transition: all 0.5s;
          h2 {
            color: #444444;
            font-size: 18px;
            font-weight: 400;
          }
          div {
            color: #666666;
            font-size: 12px;
            line-height: 20px;
            opacity: 0.8;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .server-right {
          width: 20%;
          height: 100px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .el-icon-right {
            font-size: 22px;
            color: #c1c1c1;
            transition: all 0.5s;
          }
        }
      }
    }
  }
  .serveCase-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 64px 0 50px 0;
    .serveCase-left {
      width: 68%;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      h1 {
        color: #444444;
        font-size: 20px;
        font-weight: 500;
        line-height: 0;
      }
      h2 {
        color: #c1c1c1;
        font-size: 14px;
        margin-left: 20px;
        font-family: "FZCYJ";
        letter-spacing: 1px;
        font-weight: 400;
        line-height: 0;
      }
    }
    .serveCase-tab {
      width: 25%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      .tabName {
        width: 66px;
        height: 30px;
        display: block;
        color: #666666;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: #3488ea;
        }
      }
      .active {
        width: 66px;
        height: 30px;
        display: block;
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        background: #3488ea;
      }
    }
    .serveCase-right {
      width: 7%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: #666666;
      font-size: 13px;
      .more-news {
        cursor: pointer;
        color: #666666;
      }
      .more-news:hover {
        color: #3488ea;
      }
    }
  }
  .imgfont-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 100px;
    .medical-left:hover {
      .img-top {
        overflow: hidden;
        img {
          transform: scale(1.1);
          transition: all 0.5s;
        }
      }
    }
    .medical-left {
      width: 41%;
      display: block;
      cursor: pointer;
      .img-top {
        width: 100%;
        height: 240px;
        overflow: hidden;
        img {
          width: 100%;
          height: 240px;
          display: block;
          transform: scale(1);
          transition: all 0.5s;
        }
      }
      .medical-contain {
        width: 100%;
        height: 165px;
        background: #3488ea;
        display: flex;
        flex-direction: row;
        .appliance-left {
          width: 25%;
          height: 165px;
          display: flex;
          flex-direction: column;
          align-items: center;
          div:nth-of-type(1) {
            color: #ffffff;
            font-size: 41px;
            font-weight: bold;
            margin-top: 20px;
          }
          div:nth-of-type(2) {
            color: #ffffff;
            font-size: 13px;
            opacity: 0.6;
            font-family: "FZCYJ";
            letter-spacing: 1px;
          }
        }
        .appliance-right {
          width: 75%;
          height: 165px;
          h1 {
            width: 95%;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #ffffff;
            font-size: 18px;
            font-weight: 500;
          }
          .underline1 {
            width: 95%;
            height: 1px;
            background: #ffffff;
            opacity: 0.2;
          }
          .particulars {
            width: 95%;
            height: 87px;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #ffffff;
            font-size: 14px;
            line-height: 24px;
            opacity: 0.7;
          }
        }
      }
    }

    .medical-right {
      width: 53%;
      height: 405px;
      .medical-top:hover {
        .new-left {
          .news-title {
            color: #3488ea;
            transform: translateX(10px);
            transition: all 0.5s;
          }
        }
        .new-right {
          .angle-right {
            .fa {
              color: #3488ea;
              transform: translateX(10px);
              transition: all 0.5s;
            }
          }
        }
      }
      .medical-top {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .new-left {
          width: 80%;
          .news-title {
            width: 100%;
            height: 38px;
            display: block;
            color: #444444;
            font-size: 16px;
            font-weight: 300;
            cursor: pointer;
            transform: translateX(0);
            transition: all 0.5s;
          }
          .underline2 {
            width: 100%;
            height: 1px;
            background: #000000;
            opacity: 0.1;
          }
          .news-title-detail {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #999999;
            font-size: 14px;
            line-height: 1.8em;
            opacity: 0.7;
            margin-top: 25px;
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            cursor: pointer;
          }
        }
        .new-right {
          width: 19%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          .date-contain {
            height: 72px;
            display: flex;
            flex-direction: column;
            align-items: center;
            div:nth-of-type(1) {
              color: #888888;
              font-size: 41px;
              font-weight: bold;
            }
            div:nth-of-type(2) {
              color: #666666;
              font-size: 13px;
              opacity: 0.6;
              font-family: "FZCYJ";
              letter-spacing: 1px;
            }
          }
          .angle-right {
            width: 40%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 15px;
            cursor: pointer;
            .fa {
              color: #b7b7b7;
              font-size: 22px;
              transform: translateX(0);
              transition: all 0.5s;
            }
          }
        }
      }
      .medical-bottom-contain:hover {
        .medical-bottom {
          h3 {
            color: #3488ea;
            transform: translateX(10px);
            transition: all 0.5s;
          }
          div {
            color: #3488ea;
            transform: translateX(-10px);
            transition: all 0.5s;
          }
        }
      }
      .medical-bottom-contain {
        width: 100%;
        display: block;
        cursor: pointer;
        .medical-bottom {
          width: 100%;
          height: 65px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          h3 {
            color: #444444;
            font-size: 14px;
            font-weight: 300;
            transform: translateX(0);
            transition: all 0.5s;
          }
          div {
            color: #666666;
            font-size: 13px;
            font-family: "FZCYJ";
            letter-spacing: 1px;
            transform: translateX(0);
            transition: all 0.5s;
          }
        }
        .server-text {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
        }
        .underline3 {
          width: 100%;
          height: 1px;
          background: #000000;
          opacity: 0.1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/common/ServiceCenter.vue